import React from 'react';
import { ShieldCheck, Cpu, KeyRound } from 'lucide-react';

const LocalFirst = () => {
  return (
    <section id="local-first" className="my-20">
      <div className="bg-gradient-to-br from-apple-800/60 to-apple-900/60 backdrop-blur-md rounded-3xl border border-apple-700/40 p-8 sm:p-12 relative overflow-hidden">
        <div className="absolute -left-32 -top-32 w-72 h-72 rounded-full bg-sortio-primary/10 blur-[100px]" />
        <div className="absolute -right-32 -bottom-32 w-72 h-72 rounded-full bg-sortio-secondary/10 blur-[100px]" />

        <div className="relative z-10">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-4">
              <ShieldCheck className="text-sortio-primary" size={22} />
            </div>
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">
              On device AI for client IP
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-semibold mb-6 tracking-tight text-apple-50 max-w-3xl">
            Keep drawings, BOQs, and submittals on your machine
          </h2>

          <div className="max-w-3xl space-y-5 text-apple-200 leading-relaxed">
            <p>
              Engineering projects live or die by client confidentiality. Ministry contracts,
              infrastructure schematics, telecom site layouts, owner drawings, vendor pricing
              in BOQs: this is exactly the kind of content you may not want to send to a generic
              cloud AI service. Sortio is built for that constraint. By default, Sortio uses our
              cloud (OpenAI) to plan the sort and sends your filenames and the entities it
              extracts, with file contents sent only if you enable a content-based feature. Run a
              local LLM or bring your own key and the AI works against the files in your project
              folder, with the file contents never leaving your machine.
            </p>
            <p>
              You have two privacy first options. Run Sortio with a local LLM (no API calls,
              fully offline), or use Bring Your Own Key with your firm's own OpenAI, Anthropic,
              or Azure account, so the only contract that governs your data is the one your
              firm already signed. With either option, there is no Sortio side cloud step where
              drawings or BOQs pass through a third party.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
            <div className="bg-apple-800/40 rounded-2xl border border-apple-700/50 p-6">
              <div className="flex items-center mb-3">
                <Cpu className="text-sortio-primary mr-2" size={18} />
                <h3 className="text-base font-medium text-apple-50">Local LLM mode</h3>
              </div>
              <p className="text-sm text-apple-200 leading-relaxed">
                Run an on device model (Llama, Mistral, or any GGUF compatible LLM) and Sortio
                will sort your drawings entirely offline. Useful for air gapped environments,
                ministry and defense clients, and anyone who needs zero outbound network calls
                during AI inference.
              </p>
            </div>

            <div className="bg-apple-800/40 rounded-2xl border border-apple-700/50 p-6">
              <div className="flex items-center mb-3">
                <KeyRound className="text-sortio-primary mr-2" size={18} />
                <h3 className="text-base font-medium text-apple-50">BYOK (Bring Your Own Key)</h3>
              </div>
              <p className="text-sm text-apple-200 leading-relaxed">
                Plug in your firm's OpenAI, Anthropic, or Azure OpenAI key. Sortio calls the
                provider directly from your Mac under your DPA, never via Sortio servers. BYOK
                usage is never metered by Sortio and does not count against your Sortio AI
                allowance, so unlimited sorting on large project archives is feasible.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalFirst;
